import { ServiceSessionStorageBase } from "@/services/storage/base/service-session-storage-base";
import {
  FileSongData,
  FileSongStorageData,
  RecordAudioHandler,
} from "@/services/storage/base/storage-abstractions";
import { base64ToBlob, blobToBase64 } from "@/utils/blob-utils";

export class RecordAudioStorageMixin
  extends ServiceSessionStorageBase
  implements RecordAudioHandler
{
  private readonly recordAudioKey = "recordAudioData";

  async getRecordAudioData(): Promise<FileSongData | null> {
    const jsonRecordAudioData = await this.getDataDB(this.recordAudioKey);
    if (!jsonRecordAudioData) {
      return null;
    }

    const recordAudioData = JSON.parse(
      jsonRecordAudioData,
    ) as FileSongStorageData;
    return {
      songFile: new File(
        [base64ToBlob(recordAudioData.songFile)],
        recordAudioData.title,
        { type: "audio/mp3" },
      ),
    };
  }

  async setRecordAudioData(localFile: File | null): Promise<void> {
    if (localFile === null) {
      await this.deleteDataDB(this.recordAudioKey);
      return;
    }

    const base64data = await blobToBase64(localFile);
    const jsonData = JSON.stringify({
      songFile: base64data,
      title: localFile.name,
    });

    await this.saveDataDB(this.recordAudioKey, jsonData);
  }
}
